import { Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: 'highlight'
})
export class HighlightSearch implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any, args: any): any {
    if (!args || !value) return value;

    const ogText = args.replaceAll(/['"]/g, '');
    const a_b_relation = [
      { a: "ا", b: "أ" }, { a: "ا", b: "إ" }, { a: "ا", b: "ى" },
      { a: "أ", b: "ى" }, { a: "أ", b: "إ" }, { a: "إ", b: "ى" },
      { a: "ه", b: "ة" }, { a: "و", b: "ؤ" }, { a: "ت", b: "ة" },
      { a: "ض", b: "ظ" }, { a: "ئ", b: "ء" },
    ];

    const containsPercentSign = ogText.includes("%");
    console.log(containsPercentSign);

    const SearchTerm = new Set();

    function handleArabicPrefixes(item: string) {
      if (item.startsWith("ال")) {
        SearchTerm.add(item.substring(2));
        SearchTerm.add(item);
        console.log(`Removed "ال" from ${item} to ${item.substring(2)}`);
      } else {
        SearchTerm.add(`ال${item}`);
        SearchTerm.add(item);
      }
    }

    const args_array = ogText.split(/\s+/);

    if (value) {
      var replacedValue = value.replace("<mark class='highlightedtext'>", "").replace("</mark>", "");
    }


    const highlighted = new Set();

    args_array.forEach((ele: string) => {
      if (ele.length === 0) return;

      // Match in a case-insensitive manner
      a_b_relation.forEach((rel) => {
        const re = new RegExp(
          HighlightSearch.makeValidRegExp(ele.replace(new RegExp(rel.a, 'g'), rel.b)),
          'gi'
        );

        const match = replacedValue.match(re);

        if (match) {
          const matchValue = match[0];
          if (!highlighted.has(matchValue)) {
            if (matchValue.length > 1) {
              replacedValue = replacedValue.replace(re, `<mark class='highlightedtext'>${matchValue}</mark>`);
              highlighted.add(matchValue);
            }

          }
        }
      });

      handleArabicPrefixes(ele);
    });

    SearchTerm.forEach((item: any) => {
      replacedValue = replacedValue.replace(item.re, `<mark class='highlightedtext'>${item.match}</mark>`);
    });

    //console.log("REEEEEEEMMMAAAAATTTTCCCCHHHHHHHH",replacedValue)

    return this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(replacedValue));
  }


  static makeValidRegExp(input: string): string {
    try {
      new RegExp(input);
      return input; // If no error is thrown, the input is already a valid regular expression.
    } catch (error) {
      if (error instanceof SyntaxError) {
        const escapedInput = input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return escapedInput;
      } else {
        throw error; // Pass on any other error (e.g., a runtime error).
      }
    }
  }
}
